/**
 * Pill tabs for the measurement tables.
 *
 * Progressive enhancement: with no JS every panel after the first stays hidden
 * and the tab strip does nothing, so the first table still reads. The element
 * only takes over once it upgrades.
 */
class TbpsTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    if (this.tabs.length < 2) return;

    this.tabs.forEach((tab, index) => {
      tab.setAttribute('tabindex', tab.getAttribute('aria-selected') === 'true' ? '0' : '-1');
      tab.addEventListener('click', () => this.select(index));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });
  }

  select(index) {
    this.tabs.forEach((tab, i) => {
      const selected = i === index;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.setAttribute('tabindex', selected ? '0' : '-1');
    });
    this.panels.forEach((panel, i) => {
      panel.toggleAttribute('hidden', i !== index);
    });
  }

  onKeydown(event, index) {
    const last = this.tabs.length - 1;
    let next = null;

    if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
    if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = last;
    if (next === null) return;

    event.preventDefault();
    this.select(next);
    this.tabs[next].focus();
  }
}

if (!customElements.get('tbps-tabs')) {
  customElements.define('tbps-tabs', TbpsTabs);
}
